import React from 'react';
import PropTypes from 'prop-types';
import { TagWrapper } from './style';
import Text from '../Text';
import Icon from '../Icon';

const TagBadge = ({ item, isActive, onClick }) => {
  return (
    <TagWrapper
      onClick={onClick}
      className={isActive ? 'active' : ''}
      style={{ cursor: typeof onClick === 'function' ? 'pointer' : 'default' }}
    >
      <Text type="b3">{item?.name}</Text>
      {typeof onClick === 'function' && (
        <Icon type="plus" size={19} rotate={isActive ? 45 : 0} />
      )}
    </TagWrapper>
  );
};

TagBadge.propTypes = {
  item: PropTypes.object,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};

export default TagBadge;
